import Header from './sections/header/Header';
import Hero from './sections/hero/Hero';
import Projects from './sections/projects/Projects';
import About from './sections/about/About';
import Activities from './sections/activities/Activities';
import Services from './sections/services/Services';
import Videos from './sections/stats/Videos';
import Footer from './sections/footer/Footer';
import classes from './home.module.scss';

const Home = () => {
    return (
        <div className={classes.Page}>
            <Header />
            <main>
                <Hero />
                <Projects />
                <About />
                <Activities />
                <Services />
                <Videos />
            </main>
            <Footer />
        </div>
    );
};

export default Home;
